import React from "react";

const PatientEnrolmentBookEyeCheckStepTwo = () => (
  <section
    className="background-white"
    id="patient-enrolment-book-eye-check-step-two"
  >
    <div className="mdc-layout-grid max-width">
      <div className="mdc-layout-grid__inner">
        <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-8-tablet">
          <h2 className="step-heading">Step 2</h2>

          <div className="section-content">
            <p className="step-heading-label">Make an appointment</p>
          </div>

          <div className="section-content">
            <p>
              If you already have an eye care provider, make an appointment with
              them and take the KeepSight visit information with you.
            </p>
          </div>

          <div className="section-content">
            If you don't have an eye care provider:
          </div>

          <div className="section-content">
            <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 mdc-layout-grid__cell--span-12-tablet text-center">
              <a
                href="/provider_search"
                id="search-for-local-optometrist"
                className="search-local-optom secondary-button"
              >
                <i
                  className="material-icons mdc-button__icon"
                  aria-hidden="true"
                >
                  search
                </i>
                <div className="button-icon-text">
                  Search for your local optometrist
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-8-tablet text-center">
          <img
            src="/images/step3-make-an-appointment.jpg"
            alt="Make an appointment"
          />
        </div>
      </div>
    </div>
  </section>
);

export default PatientEnrolmentBookEyeCheckStepTwo;
